import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import Footer from "../../../components/molecules/footer/Footer";
import Header from "../../../components/molecules/header/Header";
import { getResolucion } from "../../../components/services/VidaAdministrativaService";
import { useEffect, useRef, useState } from "react";
import { SpinnerCircle } from "../../../components/atoms/spinner/Spinner";


const ResolucionMisActos = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [solicitud, setSolicitud] = useState("");
  const abortControllerRef = useRef(null);

  useEffect(() => {
    const controller = new AbortController();
    abortControllerRef.current = controller;

    getResolucion(params?.xsolactadm, controller.signal)
      .then((data) => {
        if (!data || controller.signal.aborted) return;

        if (!data.toString().startsWith("Error")) {
          const reader = new FileReader();
          reader.readAsDataURL(data);
          reader.onloadend = function () {
            if (!controller.signal.aborted) {
              setSolicitud(reader.result);
              setLoading(true);
            }
          };
        } else {
          setLoading(true);
        }
      })
      .catch((err) => {
        if (err.name !== "CanceledError" && err.name !== "AbortError") {
          // console.error(err);
          setLoading(true);
        }
      });

    return () => {
      // Cancelamos si el usuario abandona la página
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, [params?.xsolactadm]);
  return (<>
    <Header />
    <div className="container-fluid" role="main" data-landmark-index="4">
      {loading ? (<>
        <div className="datosPersonalesCarrera d-flex flex-column m-2">
          <div>
            <div className="d-flex justify-content-between">
              {/*<Titulo
              clases={"subSubTituloSolicitud p-2 fw-bold"}
              tipo={"tituloCard noBg"}
              titulo={`Resolución - ${searchParams?.get('dactadm')}`}
            ></Titulo>*/}
              <h2 className="tituloAccesibilidadMini">Resolución - {searchParams?.get('dactadm')}</h2>

            </div>
            <div className="separador"></div>
          </div>

          <div className="formulario">
            <>
              <div className="m-2"></div>
              <div className="m-3 card scroll-list container-list-border">
                <div className="gridPresentar">
                  <div className="iframePresentar pt-3">
                    {solicitud ? (
                      <object
                        data={solicitud}
                        type="application/pdf"
                        height="500"
                        width="100%"
                        aria-label="PDF del borrador"
                        className="rounded"
                        name="sol"
                      />
                    ) : (
                      <p style={{ height: "500px", width: "100%" }}>
                        No se ha encontrado el documento en el
                        sistema.
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </>
            <div className="gridBotones mb-2">
              <button
                id="volver"
                className="btnRed rounded btnCancelarDocumentacion"
                type="button"
                onClick={() => navigate("/misActosAdmin")}
              >
                <i className="fa-solid fa-rotate-left"></i> Volver
              </button>
            </div>
          </div>
        </div>
      </>) : (<div className=""><SpinnerCircle /></div>)}
    </div>
    <Footer />
  </>)
}

export default ResolucionMisActos;